import moment from 'moment';

export function getTimeDiffShort(
  start: string | Date,
  end: string | Date
): string {
  const startTime: moment.Moment = moment(start);
  const endTime: moment.Moment = moment(end);

  const diff: moment.Duration = moment.duration(endTime.diff(startTime));

  if (!start || !end) {
    return '0m';
  }

  const totalMinutes = diff.asMinutes();
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);

  if (totalMinutes < 60) {
    return `${minutes}m`;
  } else if (totalMinutes < 1440) { // less than 24 hours
    if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  } else {
    return `${Math.floor(diff.asDays())}d`;
  }
}
export function calculateScheduleTimeDiff(
  start: string | Date,
  end: string | Date
): string {
  if (!start || !end) {
    return '0m';
  }

  const startDate = start instanceof Date ? start : new Date(start);
  const endDate = end instanceof Date ? end : new Date(end);

  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return '0m';
  }

  const baseDate = new Date();
  baseDate.setHours(0, 0, 0, 0);

  const startTime = new Date(baseDate);
  startTime.setHours(startDate.getHours(), startDate.getMinutes(), 0, 0);

  const endTime = new Date(baseDate);
  endTime.setHours(endDate.getHours(), endDate.getMinutes(), 0, 0);

  const diffMs: number = endTime.getTime() - startTime.getTime();
  const isNegative: boolean = diffMs < 0;

  const totalMinutes = Math.floor(Math.abs(diffMs) / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const sign = isNegative ? '-' : '';

  if (totalMinutes === 0) {
    return '0m';
  } else if (totalMinutes < 60) {
    return `${sign}${minutes}m`;
  } else if (totalMinutes < 1440) {
    if (minutes === 0) {
      return `${sign}${hours}h`;
    } else {
      return `${sign}${hours}h ${minutes}m`;
    }
  } else {
    return `${sign}${Math.floor(totalMinutes / 1440)}d`;
  }
}